import moment from 'moment-timezone'
import config from '../config/config'
import firebase from 'firebase/app'
import 'firebase/database'
const momentDate = require('moment');

firebase.initializeApp(config.FIREBASE_CONFIG)
export const database = firebase.database()

import loginLayoutReducer from '../layouts/LoggedIn/reducer'
import * as actions from '../layouts/LoggedIn/actions'
import store from '../config/store'
import reducer from '../config/reducer'

export const checkAdmin = () => {
  const token = getToken()
  return fetch(`${config.URI}/api/v1/check_admin`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': token,
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .then(res => {
      if (res.status && res.status === 'success') {
        if (!res.data.admin) {
          let warning = checkJapanese() ? '管理者ユーザを使用してください' : 'Use admin user';
          alert(warning)
          window.location = '/'
        }
        return
      }
    })
    .catch((error) => {
      let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
      alert(warning)
    })
}

export const checkFailedPaymentStatus = (props) => {
  let {
    failed_payment_count,
    card_update_date,
    failed_payment_date,
  } = props;

  let failed_payment_status = true
  if (card_update_date !==  null)
    failed_payment_status = failed_payment_date > card_update_date;

  return failed_payment_count > 0 && failed_payment_status
}

export const getToken = () => {
  const token = sessionStorage.getItem('authToken')
    ? sessionStorage.getItem('authToken')
    : localStorage.getItem('authToken')
  return token
}

export const checkAdminUrl = url => {
  const substr = 'admin'
  return url.indexOf(substr) !== -1
}

export const getImageURI = (userid, neglect) => {
  return userid ? `${config.URI}/api/v1/image/${userid}` : neglect
}

export const isAccountFree = userPlan => {
  if (userPlan === 'free' || !userPlan) {
    return true
  } else {
    return false
  }
}

export const isAccountStartter = userPlan => {
  const substr = 'starter'
  return userPlan ? userPlan.indexOf(substr) !== -1 : false
}

export const isAccountPremium = userPlan => {
  if (userPlan === 'premium') {
    return true
  } else {
    return false
  }
}

export const checkJapanese = () => {
  let locale = localStorage.getItem('locale')
  if (locale === 'ja') {
    return true
  } else if (locale === 'en') {
    return false
  } else {
    let default_lang =
      (window.navigator.languages && window.navigator.languages[0]) ||
      window.navigator.language ||
      window.navigator.userLanguage ||
      window.navigator.browserLanguage
    if (default_lang === 'en') {
      localStorage.setItem('locale', 'en')
      return true
    } else {
      localStorage.setItem('locale', 'ja')
      return false
    }
  }
}

export const isActivate = pathname => {
  const substr = 'activate'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const isPassword = pathname => {
  const substr = 'password'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const isChangeEmail = pathname => {
  const substr = 'change_email'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const isSignUp = pathname => {
  const substr = 'signup'
  return pathname ? pathname.indexOf(substr) !== -1 : false
}

export const flattenMessages = (nestedMessages, prefix = '') => {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key]
    let prefixedKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      messages[prefixedKey] = value
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey))
    }

    return messages
  }, {})
}

export const getTimezones = () => {
  const timeZones = moment.tz.names()
  let allTimezones = []
  for (let i in timeZones) {
    allTimezones.push(
      ' (GMT' + moment.tz(timeZones[i]).format('Z') + ') ' + timeZones[i]
    )
  }
  return allTimezones
}

export const parseQuery = qstr => {
  let query = {}
  const a = (qstr[0] === '?' ? qstr.substr(1) : qstr).split('&')
  for (let i = 0; i < a.length; i++) {
    const b = a[i].split('=')
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || '')
  }
  return query
}

export const createMarkup = text => {
  return {
    __html: /\\r|\\n|\n/.test(text)
      ? text.replace(/\\r|\\n|\n/g, '<br />')
      : text
  }
}

export const getCustomerBillings = () => {
  const APIRoomurl = `${config.URI}/api/v1/billings`
  return fetch(`${APIRoomurl}`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .catch((e) => {
      let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
      alert(warning)
    })
}

export const getExpiresIn = async (parent) => {
  let expires_in = 'never';
  if (parent.fvlite_expire_flag !== null && parent.fvlite_auto_trial_users_expiration_date !== null) {
    let currentDate = momentDate()
    let expire_date = momentDate(parent.fvlite_auto_trial_users_expiration_date)
    expires_in = expire_date.diff(currentDate, 'days')
  }
  const fvDomainResponse = await getFvContract()
  if (expires_in !== 'never' && fvDomainResponse.data.domain.fvlite_auto_trial === false) {
    expires_in = 'never'
  }

  return expires_in;
}

export const getPlan = (isWebinar = false) => {
  const APIRoomurl = `${config.URI}/api/v1/fvrooms?is_webinar=${isWebinar}`
  return fetch(`${APIRoomurl}`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    // .then(res => {
    //   if (!res.data.sessions_plan) {
    //     return 'free'
    //   }
    //   return res.data.sessions_plan
    //   return res
    // })
    .catch((e) => {
      let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
      alert(warning)
    })
}

export const getInvoice = () => {
  return fetch(`${config.URI}/api/v1/stripe_get_invoice`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .then(res => {
      return res.data
    })
    .catch((e) => {
      let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
      alert(warning)
    })
}

export const getCustomer = () => {
  return fetch(`${config.URI}/api/v1/stripe_get_customer`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .then(res => {
      return res.data
    })
    .catch((e) => {
      // alert("サーバーとの接続にエラーが発生しました。")
    })
}

export const getLfvMasterPlans = () => {
  const APIurl = `${config.URI}/api/v1/lfv_master_plans`
  return fetch(`${APIurl}`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .catch((e) => {
    })
}

export const validateFvDomain = async (fvdomain, $this) => {
  const APIurl = `${config.URI}/api/v1/fvdomains/validate_domain?fvdomain=${fvdomain}`
  let res = await fetch(`${APIurl}`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .catch((e) => {
      console.log(e)
    });

  if (res.status && res.status !== 'success') {
    let message = 'ドメインが存在します。別のドメインを選択してください。'
    if (!checkJapanese) {
      message = 'Domain exists. Please select another domain.';
    }
    $this.setState({domainNameErrors: message})
  }
}


export const getFvContract = () => {
  const APIurl = `${config.URI}/api/v1/get_fvcontract`
  return fetch(`${APIurl}`, {
    method: 'GET',
    headers: {
      'Authenticity-Token': getToken(),
      'Content-Type': 'application/json'
    }
  })
    .then((temp) => temp.json())
    .catch((e) => {
    })
}

export const checkIOS = () => {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isChrome = navigator.vendor.includes('Google Inc');
  return iOS && !isChrome;
}

export const checkMobile = () => {
  const iOS = /iPhone/.test(navigator.userAgent) && !window.MSStream
  const Android = /android|Android/.test(navigator.userAgent)
  return iOS || Android
}
export const checkPad = () => {
  const iOS = /iPad|iPod/.test(navigator.userAgent) && !window.MSStream
  return iOS
}

export const checkView = () => {
  let width = window.innerWidth;
  let height = window.innerHeight;
  store.dispatch(actions.updateView(height, width))
  window.addEventListener('resize', () => {
    width = window.innerWidth;
    height = window.innerHeight;
    store.dispatch(actions.updateView(height, width))
  });
  const view = width <= 900 ? 'mobile' : 'desktop'
  return view;
}

export const executeA8Script = async (token, data, invoice_id)  => {
  const transaction_id = `${data.userId}${data.domain_name}${window.location.host}${invoice_id}`;

  const payload = {
    token: token,
    transaction_id: transaction_id.replace(/\./g, ''),
    price: 8000,
    code: "ba" + data.accounts_allowed + "r" + data.rooms_allowed
  }
  console.log("executeA8Script -> payload", payload);

  if (false) {
    executeA8FEScript(payload);
  }

  if (true) {
    executeA8BEScript(payload);
  }
}

const executeA8BEScript = (payload) => {
  const apiToken = getToken();

  return fetch(`${config.URI}/api/v1/send_data_affiliate`, {
    method: 'POST',
    headers: {
      'Authenticity-Token': apiToken,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then((temp) => temp.json())
    .then(res => {
      if (res.status && res.status === 'success') {
        console.log("A8 http call succeed", res)
        return
      } else {
        console.log("A8 http call error", res)
      }
    })
    .catch((error) => {
      console.log("A8 http call error", error)
    })
}

const executeA8FEScript = (payload) => {
  const code = payload.code.replace('ba', 'fa')
  const url = `https://px.a8.net/a8fly/earnings?a8=${payload.token}&pid=s00000021221001&so=${payload.transaction_id}&si=${payload.price}-1-${payload.price}-${code}&currency=JPY`;
  return fetch(`${url}`, {
    method: 'GET'
  })
    .then((temp) => temp.json())
    .then(res => {
      console.log("Front end A8 result", res);
      if (res && res.status === 'success') {
        console.log("A8 FE call success", res)
      }else{
        console.log("A8 FE call error", res)
      }
    })
    .catch((error) => {
      console.log("A8 FE call error", error)
    })

}

export const loadAffiliateScript = () => {
  const uqid = "adb0ce6466b25ba8";
  let cid;
  const hostname = window.location.hostname;

  if (hostname === 'admin.lfv.jp') {
    cid = "63";
  } else{
    cid = "65";
  }
  console.log("Hostname", hostname)
  console.log("uqid", uqid);
  console.log("cid", cid);

  let a = document.createElement("script");
  a.dataset.uqid = uqid; a.dataset.cid = cid; a.id = "afadfpc-" + Date.now();
  console.log("a", a)
  a.src="//ac.protostar-media.co/fpc/cookie_js.php?scriptId="+encodeURIComponent(a.id);
  document.body.appendChild(a);
}

export const executeAffiliateScript = (data, invoice_id) => {
  console.log("Invoice Id", invoice_id)
  console.log("Domain Name", data.domain_name);
  console.log("User Id", data.userId);
  console.log("Initial Price", data.initial_price)
  console.log("Total price", data.total_price)
  const url = 'http://ac.protostar-media.co/ac/action_js.php';
  if(!isMyScriptLoaded(url)){
    console.log(data);
    const uqid   = "adb0ce6466b25ba8";
    let cid;
    const hostname = window.location.hostname;
    if (hostname === 'admin.lfv.jp') {
      cid = "63"
    } else {
      cid = "65"
    }
    const uid   = invoice_id; // Needs to add invoice id
    const uid2   = data.userId + data.domain_name + window.location.host + invoice_id;
    const af   = "";
    const pid    = "";
    const amount = data.total_price + data.initial_price;
    const a = document.createElement("script");
    a.src="//ac.protostar-media.co/ac/action_js.php";
    a.id = "afadaction-" + Date.now();
    console.log("Hostname", hostname)
    console.log("cid: ", cid);
    console.log("af", af);
    console.log("uid", uid);
    console.log("uid2", uid2)
    console.log("amount", amount);
    console.log("uqid", uqid)
   a.addEventListener("load",function(){(new fpcAction(a.id)).action(cid, af, [uid, uid2], pid, amount, uqid)});
  // a.addEventListener("load",function(){console.log("Script loaded")});
    document.body.appendChild(a);
  }

}

function isMyScriptLoaded(url) {
  var scripts = document.getElementsByTagName('script');
  for (var i = scripts.length; i--;) {
      if (scripts[i].src == url) return true;
  }
  return false;
}


export function getRoomStatus(connectionType, roomName, domainName, isWebinar) {
  //  http://localhost:4500
  // `https://${config.URI}/roomstatus?connectionType=${connectionType}&roomName=${roomName}&domainName=${domainName}`;
  return fetch(`${config.URI}/roomstatus?connectionType=${connectionType}&roomName=${roomName}&domainName=${domainName}&isWebinar=${isWebinar}`, {
    method: "GET",
  }).then(r => r.json())
}

export const getRoomInfo = (roomName, isWebinar, domainName) => {
  return window.fetch( config.URI + '/api/v1/fv_room_check', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: 'domain_name=' + domainName + '&name=' + roomName + '&is_webinar=' + isWebinar
  }).then(blob => {
    if(!blob.ok) {
      return {errors: {maintenanceMode: true}};
    } else {
      return blob.json()
    }
  }).catch(error => {
    return {errors: {maintenanceMode: true}};
  })
}

export const deleteRoom = (id, token) => {
  return fetch(`${config.URI}/api/v1/rooms/${id}`, {
    method: 'delete',
    headers: {
      'Authenticity-Token': token,
      'Content-Type': 'application/json'
    }
  })
  .then((temp) => temp.json())
}

export const randomName = () => {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < 20; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  return text
}

export function getOrientation() {
  if (window.matchMedia("(orientation: landscape)").matches) {
    return 'landscape';
 }

 return 'portrait';
}

export function isEmailValid(email) {
  let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(!regEmail.test(email)){
    return false;
  } else {
    return true;
  }
}

const objectKeysToLowerCase = (origObj) => {
  return Object.keys(origObj).reduce(function (newObj, key) {
      let val = origObj[key];
      let newVal = (typeof val === 'object') ? objectKeysToLowerCase(val) : val;
      newObj[key.toLowerCase()] = newVal;
      return newObj;
  }, {});
}

function getCSVFieldNames(isJapanese) {
  return {
    name: isJapanese ? "名前" : "name",
    email: isJapanese ? "メールアドレス" : "email",
    roles: isJapanese ? "役割(ホスト/ゲスト)" : "roles (host/participant)"
  };
}

export function validateCSVData(data, addresses, isJapanese) {
  console.log(data);
  const fields = getCSVFieldNames(isJapanese);

  try {
    data = data.map(d => isJapanese ? d : objectKeysToLowerCase(d)).filter(d => {
      // Check If all require field are there, not empty and not duplicated
      if(
        (d.hasOwnProperty(fields.name) && d.hasOwnProperty(fields.email) && d.hasOwnProperty(fields.roles))
        && (d[fields.name] !== ''  && d[fields.email] !== '' && d[fields.roles] !== '') &&
        (!addresses.find(a => a.email_address === d[fields.email]))
      ){
        return d;
      }
    }).map(d => ({
      name: d[fields.name],
      email_address: d[fields.email],
      role: isJapanese ? translateRoles(d[fields.roles]) : translateEnRoles(d[fields.roles])
    }));
    return data;
  } catch (error) {
    console.log("Error while validating the csv data: ", error);
    return [];
  }
}

function translateEnRoles(data) {
  return data.split(',').map(role => {
    if(role.toLowerCase() === 'host') {
      return 'host'
    } else if(role.toLowerCase() === 'participant') {
      return 'participant'
    } else {
      return '';
    }
  }).filter(r => r !== "").join(',');
}

function translateRoles(data) {
  return data.split(',').map(role => role === 'ホスト' ? 'host' : 'participant').join(',');
}

export function getURL(name, domainUrlName, domainType, adminGuestURL) {
  let url = 'https://' + domainUrlName + '.lfv.jp/' + name;
  let subDomain = config.URI === 'https://workshop.tokyo' ? 'fv' : 'video-dev';

  if (domainType === 'Path Domain') {
    url = 'https://' + subDomain + '.lfv.jp/' + domainUrlName + '/' + name;
  }

  if (adminGuestURL) {
    url += '?video=true'
  }
  return url
}

export function copyGuestURL(name, domainUrlName) {
  return 'https://' + domainUrlName + '.lfv.jp/' + name;
}

export function copyHostURL(room, domainUrlName, domainType, adminGuestURL) {
  let url = getURL(room.fvroom_name, domainUrlName, domainType, adminGuestURL)
  if (room.locked && room.hosttoken) {
    let hostUrlParam = adminGuestURL ? '&hosttoken=' : '?hosttoken='
    url = getURL(room.fvroom_name, domainUrlName, domainType, adminGuestURL) + hostUrlParam + room.hosttoken
  } else {
    url = url + '?host=true';
  }
  return url
}

export function copyWebinarURL(name, domainUrlName, domainType, adminGuestURL) {
  return getURL(name, domainUrlName, domainType, adminGuestURL);
}

export function copyWebinarPublisherUrl(room, domainUrlName, domainType, adminGuestURL) {
  let webinarUrl = adminGuestURL ? '&publisher=true' : '?publisher=true'
  let url = getURL(room.fvroom_name, domainUrlName, domainType, adminGuestURL) + webinarUrl;
  if (room.locked && room.hosttoken) {
    url += `&hosttoken=${room.hosttoken}`
  }
  return url;
}

export function downloadCsv(isJapanese) {
  const a = document.createElement('a');
  a.href = `/${isJapanese ? 'JP' : 'EN'}.csv`;
  a.textContent = 'download';
  document.body.append( a );
  a.click();
  a.remove();
}

export function isIpadOS() {
  return navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    (/MacIntel/.test(navigator.platform) || (/iPad/).test(navigator.platform));
}

export function showNotification(notificationSystem, message, level, autoDismiss = 0) {
  notificationSystem.addNotification({
    message,
    level,
    position: 'tr',
    autoDismiss
  })
}



// WEBPACK FOOTER //
// src/lib/index.js